// @ts-nocheck
/* eslint-disable camelcase */
import React, { Component } from 'react';
import { inject, observer } from "../../../../stores/mobx-compat";
import qs from 'query-string';
import _ from 'lodash';
import { capitalize } from 'lodash';
import { withRouter } from '../../../../router-compat';

import configs from '../configs';
import { IntegrationLayout } from '../_shared';
import Card, { CardHead } from '../../../ui/Card';
import Button from '../../../ui/Button';
import Switch from '../../../ui/Switch';
import Pill from '../../../ui/Pill';
import Alert from '../../../ui/Alert';

const ShopifySetupPanel = () => (
  <Card padded>
    <CardHead title="Setup" />
    <ol className="m-0 pl-5 flex flex-col gap-2 text-[13px] leading-relaxed">
      <li>Make a Shopify account at <a href="https://www.shopify.com/" target="_blank" rel="noopener noreferrer" className="text-mov-accent-ink underline">shopify.com</a> if you don&apos;t have one.</li>
      <li>Head to <a href="https://apps.shopify.com/" target="_blank" rel="noopener noreferrer" className="text-mov-accent-ink underline">apps.shopify.com</a>.</li>
      <li>Search for: Capture by Movology.</li>
      <li>Click Add App.</li>
      <li>Authorize by clicking the Install App button.</li>
    </ol>
  </Card>
);

const PricingTiers = inject('store')(observer(({ store }) => {
  const shopify = store.integrations.Shopify;
  const currentPlan = _.get(shopify.configs, 'integrationPricingTier');
  return (
    <div
      className="grid gap-4"
      style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))' }}
    >
      {shopify.tierList.map((t) => (
        <Card key={t.name} padded>
          <h3 className="m-0 text-[15px] font-semibold">{t.name}</h3>
          <p className="m-0 mt-1 text-[12.5px] text-mov-ink-soft">{t.header}</p>
          <div className="mt-3 mb-2">
            <div className="mov-display" style={{ fontSize: 32, lineHeight: 1 }}>${t.price}</div>
            <div className="text-[11.5px] mov-mono uppercase tracking-wider text-mov-ink-mute">per month</div>
          </div>
          <ul className="m-0 p-0 list-none flex flex-col gap-1.5 text-[13px] mb-3">
            {t.planDescription.map((d) => (
              <li key={d} className="flex items-start gap-2">
                <span className="text-mov-accent-ink">›</span>
                <span>{d}</span>
              </li>
            ))}
          </ul>
          {t.name === currentPlan ? (
            <Pill tone="green" dot>Current plan</Pill>
          ) : (
            <Button
              variant="primary"
              onClick={async () => {
                const { paymentAuthLink } = await shopify.paymentUrl(t.name);
                window.location.href = paymentAuthLink;
              }}
            >
              Select plan
            </Button>
          )}
        </Card>
      ))}
    </div>
  );
}));

class Shopify extends Component {
  state = { active: 'setup' };

  componentDidMount() {
    this.props.store.integrations.Shopify.getConfigs();
    const { code, hmac, shop, state, charge_id } = qs.parse(
      this.props.location.search, { ignoreQueryPrefix: true },
    );
    if (code) {
      this.props.store.integrations.Shopify.getTokens({ code, hmac, shop, state })
        .then(() => this.props.history.replace(this.props.location.pathname));
    }
    if (charge_id) {
      this.props.store.integrations.Shopify.activateCharge(charge_id)
        .then(() => this.props.store.integrations.Shopify.getConfigs());
    }
  }

  toggle = (v) => {
    this.props.store.integrations.Shopify.setConfigField('enabled', v);
  }

  render() {
    const sh = this.props.store.integrations.Shopify;
    const linked = !!sh.configs.storeDetails;
    const { storeDetails, integrationPricingTier } = sh.configs;

    const tabs = linked
      ? [{ value: 'setup', label: 'Setup' }, { value: 'pricing', label: 'Pricing' }]
      : [{ value: 'setup', label: 'Setup' }];

    const status = linked ? [
      { name: 'Pricing tier', value: capitalize(integrationPricingTier) },
      { name: 'Store name', value: storeDetails.name },
      { name: 'Email', value: storeDetails.email },
      { name: 'Domain', value: storeDetails.domain },
    ] : null;

    return (
      <IntegrationLayout
        config={configs.Shopify}
        tabs={tabs}
        active={this.state.active}
        onTab={(v) => this.setState({ active: v })}
      >
        {this.state.active === 'setup' ? (
          <>
            {!linked && <ShopifySetupPanel />}

            {linked && (
              <>
                <Alert tone="info" title="Manage your plan in the Pricing tab.">
                  Upgrade or downgrade from the Pricing tab above.
                </Alert>

                <Card padded className="mt-5 mb-5">
                  <CardHead title="Status" />
                  <dl className="m-0 grid gap-2.5 text-[13px]">
                    {status.map((r) => (
                      <div key={r.name} className="flex justify-between gap-3" style={{ borderBottom: '1px dashed var(--mov-line)', paddingBottom: 8 }}>
                        <dt className="text-mov-ink-mute mov-mono text-[11px] uppercase tracking-wider">{r.name}</dt>
                        <dd className="m-0 font-medium">{r.value}</dd>
                      </div>
                    ))}
                  </dl>
                </Card>

                <Card padded>
                  <CardHead
                    title="Manage integration"
                    action={(
                      <div className="flex items-center gap-2">
                        <span className="text-[12.5px] text-mov-ink-soft">Enabled</span>
                        <Switch checked={!!sh.configs.enabled} onChange={this.toggle} />
                      </div>
                    )}
                  />
                  <div className="flex justify-end">
                    <Button
                      variant="primary"
                      loading={sh.loading}
                      disabled={sh.loading}
                      onClick={() => sh.updateConfigs('Shopify')}
                    >
                      Update settings
                    </Button>
                  </div>
                </Card>
              </>
            )}
          </>
        ) : (
          <PricingTiers />
        )}
      </IntegrationLayout>
    );
  }
}

export default withRouter(inject('store')(observer(Shopify)));
